export const selectIsAdminView = (state) => state.menu.isAdminView
